<template>
  <v-card flat>
    <v-card-title class="grey lighten-4 px-3 py-2">
      <v-layout row wrap>
        <v-flex sm6>
          <v-text-field append-icon="filter_list" :label="messages.label.ERRORS_FILTER" single-line hide-details
            clearable v-model="search" @input="value => filterOffersErrors(value)">
          </v-text-field>
        </v-flex>
        <v-flex sm6 class="text-xs-right">
          <span>
            <v-icon color="secondary" class="pr-2" small>info</v-icon>
            Click on a row to view error details
          </span>
          <v-tooltip bottom>
            <v-btn icon slot="activator" @click="searchPreIngestErrors" color="primary">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh Errors</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="py-2">
      <v-data-table :headers="headers" :items="filteredOffersErrors" :pagination.sync="pagination"
        :total-items="totalItems" :loading="offersErrorsLoading" :rows-per-page-items="rowsPerPagesArray">
        <!-- Items -->
        <template slot="items" slot-scope="props">
          <tr @click="toggleErrorDetails(props)" :active="!!selected && selected.id == props.item.id" class="pointer">
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left">{{ props.item._updated }}</td>
            <td class="text-xs-left">{{ props.item.providerName }}</td>
            <td class="text-xs-left">{{ truncateDetailsString(props.item.eventDetails) }}</td>
          </tr>
        </template>
        <!-- Expand -->
        <template slot="expand" slot-scope="props">
          <v-flex xs12 sm12>
            <v-layout class="red lighten-5">
              <v-flex xs4 sm4>
                <v-list two-line class="red lighten-5" subheader>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title> Media ID </v-list-tile-title>
                      <v-list-tile-sub-title>{{ checkValues(props.item.mediaId) }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Version</v-list-tile-title>
                      <v-list-tile-sub-title>{{ checkValues(props.item.version) }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title> File Name </v-list-tile-title>
                      <v-list-tile-sub-title>{{ checkValues(props.item.fileName) }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs8 sm8 class="mt-3">
                <v-alert :value="true" color="error" icon="warning" outline>
                  <code class="pa-2 elevation-0">{{ props.item.eventDetails }}</code>
                </v-alert>
              </v-flex>
            </v-layout>
          </v-flex>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_OFFERS_ERRORS }}
          </v-alert>
        </template>
        <!-- No Results -->
        <template slot="no-results">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_FILTER_ERRORS }}
          </v-alert>
        </template>
        <!-- Page Text -->
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import PreIngestService from "@/PreIngest/PreIngestService"
import * as preIngestDataService from "@/PreIngest/PreIngestDataService"
import * as utils from "@/Shared/utils"
import AppService from "@/AppService"
import {
  VOD_SYCN_EVENT_DATA_SERVICE_URL
} from "@/store/constants/getter-types"
import messages from "@/PreIngest/messages.json"

/**
 * initialData
 */
function initialData(instance) {
  return {
    search: "",
    selected: {},
    offersErrorsLoading: false,
    pagination: {
      sortBy: "",
      page: 1,
      rowsPerPage: 25,
      descending: false
    },
    totalItems: 0,
    rowsPerPagesArray: [25, 50, 75, 100],
    headers: instance.getTableHeaders(),
    offersErrors: [],
    filteredOffersErrors: [],
    errorsQueryObject: {}
  }
}

export default {
  name: "PreIngestErrors",
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState([
      "mpxParentAccount"
    ]),
    ...mapGetters([
      VOD_SYCN_EVENT_DATA_SERVICE_URL
    ])
  },
  watch: {
    /**
     * Watch handler for pagination object
     */
    pagination: {
      handler(newVal, oldVal) {
        if (this.initiatedSearch && oldVal !== newVal) {
          this.searchPreIngestErrors()
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
      this.searchPreIngestErrors()
    },

    /**
     * For filtering search result with text value
     */
    filterOffersErrors(search) {
      if (search) {
        search = search.toString().toLowerCase()
        const displayedKeys = [
          "title",
          "_updated",
          "providerName",
          "eventDetails"
        ]
        this.filteredOffersErrors = this.offersErrors.filter((obj) => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(function (key) {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(search)
            }
          })
        })
      } else {
        this.filteredOffersErrors = this.offersErrors
      }
    },

    /**
     * Get pagination params
     */
    getPageParams(pagination) {
      let startRange
      let endRange
      if (pagination.page === 1) {
        startRange = 1
        endRange = pagination.rowsPerPage
      } else {
        startRange = (pagination.page - 1) * pagination.rowsPerPage + 1
        endRange = startRange + pagination.rowsPerPage - 1
      }
      return startRange + "-" + endRange
    },

    /**
     * getSortParams - Construct sorting param
     *
     * @param  {object} pagination pagination object
     * @return {string}            ex: '<filedName>|desc'
     */
    getSortParams(pagination) {
      let sortParams = ""
      sortParams =
        !this.$lodash.isNull(pagination.sortBy) &&
          !this.$lodash.isEmpty(pagination.sortBy)
          ? pagination.sortBy
          : "updated|desc"
      if (pagination.descending) {
        sortParams += "|desc"
      }
      return sortParams
    },

    /**
     * searchPreIngestErrors - construct request object and begin to search offers errors
     */
    searchPreIngestErrors() {
      this.errorsQueryObject.range = this.getPageParams(this.pagination)
      this.errorsQueryObject.sort = this.getSortParams(this.pagination)
      this.errorsQueryObject.count = true
      this.retrievePreIngestErrors()
    },

    /**
     * retrievePreIngestErrors - Retrieve offers errors from API service
     *
     * @return {Promise}  search promise
     */
    retrievePreIngestErrors() {
      this.offersErrorsLoading = true
      this.offersErrors = []
      preIngestDataService.retrievePreIngestErrors(this.errorsQueryObject,
        this.VOD_SYCN_EVENT_DATA_SERVICE_URL)
        .then((response) => {
          if (!this.$lodash.isUndefined(response.data.entries)) {
            this.offersErrors = response.data.entries
            this.massageData()
            this.filterOffersErrors(this.search)
            this.totalItems = response.data.totalResults
          } else {
            this.offersErrors = []
          }
          this.offersErrorsLoading = false
          this.initiatedSearch = true
          return this.offersErrors
        })
        .catch((error) => {
          this.offersErrors = []
          this.filteredOffersErrors = []
          this.totalItems = 0
          this.offersErrorsLoading = false
          this.initiatedSearch = true
          return Promise.reject(error)
        })
    },

    /**
     * massageData - converting added and updated unix time stamp to local date time string
     */
    massageData() {
      let errorObject
      for (var item in this.offersErrors) {
        errorObject = this.offersErrors[item]
        // Format datetime value
        errorObject._updated = !this.$lodash.isNull(errorObject.updated)
          ? this.getLocalDateTime(errorObject.updated)
          : ""
      }
    },

    /**
     * truncateDetailsString -  for Spliting details string into short chunk size
     * @return {Array}
     */
    truncateDetailsString(details) {
      if (!this.$lodash.isUndefined(details) && details !== null) {
        let matchedArray = details.match(new RegExp(/(.|[\r\n]){1,120}/g))
        return matchedArray[0] + "..."
      } else {
        return "N/A"
      }
    },

    /**
     * getBackToSearchOffers - get Back to Offers View
     */
    getBackToSearchOffers() {
      PreIngestService.$emit("event:showOffers")
    },

    /**
     * checkValues - check the values before displaying on screen
     */
    checkValues(value) {
      if (!this.$lodash.isUndefined(value) && value !== null) {
        return value
      } else {
        return "N/A"
      }
    },
    /**
     * getTableHeaders - Construct array of objects to show table headers
     *
     * @return {array}
     */
    getTableHeaders() {
      let headers = [
        {
          text: messages.label.TH_TITLE,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_LAST_UPDATED,
          align: "left",
          value: "updated"
        },
        {
          text: messages.label.TH_PROVIDER,
          align: "left",
          value: "providerName",
          sortable: false
        },
        {
          text: messages.label.TH_DETAILS,
          align: "left",
          sortable: false,
          value: "eventDetails"
        }
      ]

      return headers
    },

    /**
     * getLocalDateTime - Retrieve local time
     *
     * @param  {Number} dateTime unix time stamp
     * @return {string}          date time in local
     */
    getLocalDateTime(dateTime) {
      return utils.getLocalDateTime(dateTime)
    },

    /**
     * Toggle error details view
     */
    toggleErrorDetails(props) {
      props.expanded = !props.expanded
      this.selected = props.item
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    this.searchPreIngestErrors()
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/PreIngest/Errors/PreIngestErrors.vue